import { render, staticRenderFns } from "./PreviousSpeedrunInfo.vue?vue&type=template&id=0c86ef47&scoped=true"
import script from "./PreviousSpeedrunInfo.vue?vue&type=script&lang=js"
export * from "./PreviousSpeedrunInfo.vue?vue&type=script&lang=js"
import style0 from "./PreviousSpeedrunInfo.vue?vue&type=style&index=0&id=0c86ef47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c86ef47",
  null
  
)

export default component.exports